const FAV_KEY = "creep.favorites.v1";
const COMPARE_KEY = "creep.compare.v1";

export const getFavorites = () => {
  try {
    const raw = localStorage.getItem(FAV_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const isFavorite = (id) => getFavorites().includes(id);

export const toggleFavorite = (id) => {
  const favs = getFavorites();
  const next = favs.includes(id) ? favs.filter((f) => f !== id) : [...favs, id];
  localStorage.setItem(FAV_KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent("creep:favorites", { detail: next }));
  return next;
};

export const getCompareIds = () => {
  try {
    const raw = localStorage.getItem(COMPARE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const toggleCompare = (id, max = 4) => {
  const ids = getCompareIds();
  let next;
  if (ids.includes(id)) {
    next = ids.filter((x) => x !== id);
  } else {
    if (ids.length >= max) return ids;
    next = [...ids, id];
  }
  localStorage.setItem(COMPARE_KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent("creep:compare", { detail: next }));
  return next;
};

export const clearCompare = () => {
  localStorage.setItem(COMPARE_KEY, JSON.stringify([]));
  window.dispatchEvent(new CustomEvent("creep:compare", { detail: [] }));
};
